export default [
    { name: 'USD', symbol: '$' },
    { name: 'EUR', symbol: '€' },
];
